import React from 'react';

export default function Header({ title, variant }) {
  const pinkBanner = variant === 'pinkBanner';
  return (
    <div className={pinkBanner ? 'lead-form-header-pink-banner' : undefined}>
      <h2
        id="leadFormTitle"
        className={`text-uppercase${pinkBanner ? ' lead-form-header-pink-banner-title' : ''}`}
      >
        {title}
      </h2>
      {!pinkBanner && (
        <div style={{ background: 'var(--vm-primary-colour)', height: 1 }} />
      )}
    </div>
  );
}
